import axiosClient from "../../system/helpers/axiosConfig";

export const postSearchPartner = (params) => {
  return axiosClient.post(`/api/admin/im/partners`, params).then((r) => r.data);
};
